import React from "react";
import { Link } from "react-router-dom";
import "./Blogs.css";
import API_CONFIG from "../config/api";

import Footer from "./Footer";

// import kid15 from "../assets/Homepage/1.png";
// import kid16 from "../assets/kid16.png";
// import kid17 from "../assets/kid17.png";
// import kid18 from "../assets/kid18.png";
// import kid19 from "../assets/kid19.png";
// import kid20 from "../assets/kid20.png";
// import kid21 from "../assets/kid21.png";
// import kid22 from "../assets/kid22.png";
// import kid23 from "../assets/kid23.png";
import blogicon from "../assets/blogicon.png";
import blogicon1 from "../assets/blogicon1.png";

const Blogs = () => {
  const blogs = [
    {
      id: "topskilldevelopment",
      img: "Polymath-images/Homepage/Blog/Frame 94.png",
      title: "Top Skills Kids Develop in Online Math Olympiads",
      date: "3 April 2025",
      excerpt:
        "In a world where critical thinking and problem-solving are more valuable than ever, Math Olympiads are emerging as a powerful tool for...",
    },
    {
      id: "onlineSummercampsareimportant",
      img: "Polymath-images/Homepage/Blog/Frame 95.png",
      title: "Why Online Summer Camps are Important for 21st-Century Kids",
      date: "3 April 2025",
      excerpt:
        "Learning to code does more than just teach a child how to build websites or apps. It fosters problem-solving skills...",
    },
    {
      id: "howtomanageyourtimewhpngileonlinelearning",
      img: "Polymath-images/Homepage/Blog/Frame 95-1.png",
      title: "How to manage your time while online learning",
      date: "3 April 2025",
      excerpt:
        "At Polymath-Kids, we take pride in the success of our students. From mastering coding to learning how to...",
    },
    // {
    //   id: "importance-21st-century-skills-2",
    //   img: kid18,
    //   title: "The Importance of 21st-Century Skills for Kids",
    //   date: "3 April 2025",
    //   excerpt:
    //     "As the world continues to evolve, so do the skills necessary to succeed in the modern workforce. At Polymath-Kids, we focus on...",
    // },
    // {
    //   id: "coding-enhances-problem-solving-2",
    //   img: kid19,
    //   title: "How Coding Enhances Problem-Solving in Kids",
    //   date: "3 April 2025",
    //   excerpt:
    //     "Learning to code does more than just teach a child how to build websites or apps. It fosters problem-solving skills...",
    // },
    // {
    //   id: "success-stories-polymath-kids-2",
    //   img: kid20,
    //   title: "Success Stories: How Polymath-Kids Transformed Learning",
    //   date: "3 April 2025",
    //   excerpt:
    //     "At Polymath-Kids, we take pride in the success of our students. From mastering coding to learning how to...",
    // },
    // {
    //   id: "importance-21st-century-skills-3",
    //   img: kid21,
    //   title: "The Importance of 21st-Century Skills for Kids",
    //   date: "3 April 2025",
    //   excerpt:
    //     "As the world continues to evolve, so do the skills necessary to succeed in the modern workforce. At Polymath-Kids, we focus on...",
    // },
    // {
    //   id: "coding-enhances-problem-solving-3",
    //   img: kid22,
    //   title: "How Coding Enhances Problem-Solving in Kids",
    //   date: "3 April 2025",
    //   excerpt:
    //     "Learning to code does more than just teach a child how to build websites or apps. It fosters problem-solving skills...",
    // },
    // {
    //   id: "success-stories-polymath-kids-3",
    //   img: kid23,
    //   title: "Success Stories: How Polymath-Kids Transformed Learning",
    //   date: "3 April 2025",
    //   excerpt:
    //     "At Polymath-Kids, we take pride in the success of our students. From mastering coding to learning how to...",
    // },
  ];

  return (
    <>
      <div className="blog-page-wrapper">
        <section className="blog-top-section">
          <h1 className="blogs-header-title">
            <span className="explore-featured">Explore Our Featured</span>{" "}
            <span className="blog-posts-color">Blog Posts</span>
          </h1>
          <p className="blogs-header-desc">
            Explore our featured blog, a hub of inspiring stories, expert
            insights, and innovative ideas designed to spark curiosity and build
            confidence in young minds through STEM and tech learning. From the
            latest trends in education to practical project guides, we cover
            everything parents and educators need to nurture future-ready
            skills.
          </p>
          <div className="blog-header-images">
            <img src={blogicon} alt="Blog Icon Left" className="blog-icon-left" />
            <img src={blogicon1} alt="Blog Icon Right" className="blog-icon-right" />
          </div>
        </section>

        <section className="featured-blogs-section">
          <div className="container">
            <div className="blog-posts-grid">
              {blogs.map((blog) => (
                <div className="blog-post-card" key={blog.id}>
                  <div className="blog-post-image">
                    <img src={`${API_CONFIG.IMAGES_URL}/${blog.img}`} alt={blog.title} />
                  </div>
                  <div className="blog-post-content">
                    <div className="blog-post-date">{blog.date}</div>
                    <h3 className="blog-post-title">{blog.title}</h3>
                    <p className="blog-post-excerpt">{blog.excerpt}</p>
                    <div className="read-more-btn-container">
                      <Link
                        to={`/blog/${blog.id}`}
                        className="read-more-btn"
                      >
                        Read More
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Blogs;